import type { ExactagData } from "../core/core.types";
import { exactagData } from "../core/data";
import { exactagScope } from "../core/utils";
import type { VerticalDataCallback } from "./collect.types";

const log = exactagScope.scope("collect.vertical");

/**
 *
 */
export const verticalDataRetrievalCallbacks: Record<
  string,
  VerticalDataCallback
> = {};



/**
 *
 *
 *
 *
 *
 */
export function registerVerticalDataCallback(
  triggerID: string,
  cb: VerticalDataCallback
): void {
  if (verticalDataRetrievalCallbacks[triggerID])
    log.warn(
      "Vertical data callback ID",
      `"${triggerID}"`,
      "already registered! It will be overwritten."
    );

  verticalDataRetrievalCallbacks[triggerID] = cb;
}

export async function addVerticalDataFromElement(this: ExactagData, element: HTMLElement) {
  const data = this;

  /*                                                           */
  const { trigger: triggerID } = element.dataset;
  if (!triggerID) {
    log.warn("No trigger ID found in element", element);
    return;
  }

  /*                                  */
  const fn = verticalDataRetrievalCallbacks[triggerID];
  if (!fn || typeof fn !== "function") {
    log.warn("No function registered for trigger ID", triggerID);
    return;
  }

  let result = fn(data);
  if(result instanceof Promise) {
      result = await result;
  }
  if (!result || typeof result !== "object") {
    log.info("No data returned from function for trigger ID", triggerID);
    return;
  }

  if (result === data) {
    log.warn(
      "Callback function for trigger ID",
      triggerID,
      "returned the same object as input!"
    );
    return;
  }

  log.info("Adding data from function for trigger ID", triggerID, result);
  Object.assign(data, result);
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export async function addVerticalsData(data = exactagData): Promise<ExactagData> {
  /*                                                 */
  const activeExactagElements = document.querySelectorAll<HTMLElement>(".exactag")
  /*       */
  for (const element of activeExactagElements) {
    await addVerticalDataFromElement.call(data, element)
  }
  return data;
}
